import React, { useState, useEffect, useContext, useRef } from 'react';

import * as htmlToImage from 'html-to-image';
import $ from "jquery";
import uniqid from 'uniqid';

import { Overlay } from '@blueprintjs/core';

import PageContext from '../Context/PageContext';

import { ExportJSON, ExportPdf } from '../Util/ExportUtil';
import { addToCart } from './Cart/command';

const CartJSON = () => {

    const queryParameters = new URLSearchParams(window.location.search);
    const productId = queryParameters.get("productId") != null ? queryParameters.get("productId") : "5604";

    const { selectedItem, setSelectedItem, jsonFormat, mapListPoint, addMapListPoint, isPortrait, setIsPortrait, pageSize,
        pageColor, mapPosition, mapIndex, mapTaille, mapUrlStyle, mapListTrace, elevationData, isMode3D, objItems, mapLock
    } = useContext(PageContext);
    const [isOpen, setIsOpen] = useState(false);
    const [isCartEmpty, setIsCartEmpty] = useState(true);
    const [productName, setProductName] = useState<any>();

    const [selectedProduct, setSelectedProduct] = useState<any>();
    const [selectedFormat, setSelectedFormat] = useState<any>();
    const [price, setPrice] = useState<any>();

    const [combinaisonsState, setCombinaisonsState] = useState<any>();

    const [isImgPreview, setIsImgPreview] = useState(false);
    const [isImgFinal, setIsImgFinal] = useState(false);
    const [imgFile, setImgFinal] = useState<any>();

    const imgElement = useRef(null);


    async function openOverlay() {

        //faudrait voir à encoder le nom d'affiche pour éviter que quelqu'un comprenne le process
        var affiche_prefixe = Date.now() + "-affiche_" + uniqid()
        var jsonName = affiche_prefixe + ".json";
        var pdfName = affiche_prefixe + ".pdf";

        //upload json and start composition asynchronously from backend with Lambda call
        /**/var isExportOK = await ExportJSON(jsonName, {
            mapListPoint, objItems, pageSize, pageColor, mapPosition, mapIndex, mapTaille, mapUrlStyle, mapListTrace, elevationData, isMode3D, isPortrait, mapLock,
            selectedItem, setSelectedItem, addMapListPoint, jsonFormat, setIsPortrait,
        });

        if (isExportOK != null && isExportOK) {

            //attention le nom de l'image est ici très important !! à changer d'ailleurs
            addToCart(productId, 1, jsonFormat.attribute_support, jsonFormat.attribute_format, pdfName);

            setIsCartEmpty(false);

            setIsOpen(true);
        }

        //just pour test
        setIsOpen(true);

    }

    function seeCart() {

        setTimeout(() => {
            window.open("https://affichemap.fr/panier/");
        }, 100);


    }


    return (
        <div className='btn-to-cart'>
            <button className='main-button download-bottom' onClick={() => openOverlay()} >
                {/*<img className='icone-button-main' src={process.env.REACT_APP_PUBLIC_URL + '/images/add-to-cart.svg'}></img>*/}
                Ajouter au panier
            </button>
            <button className={'main-button download-bottom ' + (isCartEmpty ? "" : "cart-full")} >
                <BtnCart />
            </button>
            <Overlay isOpen={isOpen} onClose={() => { setIsOpen(false); setIsImgPreview(false); setIsImgFinal(false); }} usePortal={true} portalContainer={document.getElementById('app')!}>
                <div className='overlay-cart-json'>
                    <div className='cart-header'>
                        <h3>{productName != null ? productName : "Mon affiche personnalisée"}</h3>
                    </div>
                    <div className='cart-container-json'>
                        <div style={{ position: 'relative' }} className='product-preview-container'>
                            <div className='select-cart-container'>
                                <div className='label-cart-sucess'>
                                    <div>Votre affiche est ajoutée au panier !</div>
                                </div>
                                <div className='select-cart-item'>
                                    <label htmlFor="product-select">Produit :</label>
                                    {jsonFormat.attribute_support == 'numerique-pdf' ? 'Affiche numérique' : 'Affiche imprimée'}
                                    {/*<select name="products" id="product-select" onChange={selectProduct}>
                                        {selectProduit}
    </select>*/}
                                </div>
                                <div className='select-cart-item'>
                                    <label htmlFor="format-select">Format :</label>
                                    <span> {jsonFormat.text} {(jsonFormat.subtext != null) ? jsonFormat.subtext : ''}</span>

                                    {/*<select name="format" id="format-select" onChange={selectFormatPrice}>
                                        {selectFormat}
</select>*/}
                                </div>
                                <div className='select-price-item'>
                                    <div>Prix : <span className='cart-price'>{jsonFormat.price}€</span></div>
                                </div>
                            </div>
                            <div className='select-price-container'>
                                <button className='main-button add-to-cart' onClick={() => seeCart()} >
                                    <img className='icone-button-main' src={process.env.REACT_APP_PUBLIC_URL + '/images/add-to-cart.svg'}></img>
                                    Voir le panier
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </Overlay>
        </div>
    );
};

const BtnCart = (props: any) => {

    return (
        <div className="header-cart-inner-wrap cart-show-label-false cart-style-link">
            <a style={{display: 'flex'}} href="https://affichemap.fr/panier/" aria-label="Voir le panier" className="header-cart-button">
                <span className="kadence-svg-iconset" style={{color: "#ffffff", display: 'flex'}}>
                    <svg style={{    height: '20px', width: '15px'}} className="kadence-svg-icon kadence-shopping-cart-svg" fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>Voir le panier</title><path d="M11 21c0-0.552-0.225-1.053-0.586-1.414s-0.862-0.586-1.414-0.586-1.053 0.225-1.414 0.586-0.586 0.862-0.586 1.414 0.225 1.053 0.586 1.414 0.862 0.586 1.414 0.586 1.053-0.225 1.414-0.586 0.586-0.862 0.586-1.414zM22 21c0-0.552-0.225-1.053-0.586-1.414s-0.862-0.586-1.414-0.586-1.053 0.225-1.414 0.586-0.586 0.862-0.586 1.414 0.225 1.053 0.586 1.414 0.862 0.586 1.414 0.586 1.053-0.225 1.414-0.586 0.586-0.862 0.586-1.414zM7.221 7h14.57l-1.371 7.191c-0.046 0.228-0.166 0.425-0.332 0.568-0.18 0.156-0.413 0.246-0.688 0.241h-9.734c-0.232 0.003-0.451-0.071-0.626-0.203-0.19-0.143-0.329-0.351-0.379-0.603zM1 2h3.18l0.848 4.239c0.108 0.437 0.502 0.761 0.972 0.761h1.221l-0.4-2h-0.821c-0.552 0-1 0.448-1 1 0 0.053 0.004 0.105 0.012 0.155 0.004 0.028 0.010 0.057 0.017 0.084l1.671 8.347c0.149 0.751 0.57 1.383 1.14 1.811 0.521 0.392 1.17 0.613 1.854 0.603h9.706c0.748 0.015 1.455-0.261 1.995-0.727 0.494-0.426 0.848-1.013 0.985-1.683l1.602-8.402c0.103-0.543-0.252-1.066-0.795-1.17-0.065-0.013-0.13-0.019-0.187-0.018h-16.18l-0.84-4.196c-0.094-0.462-0.497-0.804-0.98-0.804h-4c-0.552 0-1 0.448-1 1s0.448 1 1 1z"></path>
                    </svg>
                </span>
            </a></div>
    )
}



export default CartJSON;